import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ShopifyStaffStoreAction } from '@discovr/types';
import { createShopifyStaffStoresApi } from '../api/shopifyStaffStores';
import { shopifyKeys } from '../queryKeys';

const api = createShopifyStaffStoresApi();

export function useShopifyStaffStores(page: number, limit: number, pollMs: number | false = false) {
  return useQuery({
    queryKey: shopifyKeys.staffStoresPage(page, limit),
    queryFn: () => api.listStores(page, limit),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    refetchInterval: pollMs,
  });
}

export function useShopifyStaffStoreAction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ shop, action }: { shop: string; action: ShopifyStaffStoreAction }) =>
      api.runAction(shop, action),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: shopifyKeys.staffStores() });
    },
  });
}
